export default {
    GESTOR: 'N',
    SUPERVISOR: 'S',
    GDN: 'G',

    properties: {
        'N': {
            codigo: 0
        },
        'S': {
            codigo: 1
        },
        'G': {
            codigo: 2
        }
    }
}